import React from "react";
import { MapPin, Mail } from "lucide-react";

const LOGO_URL =
    "img/SAS_LOGO.png";

export default function Footer() {
    return (
        <footer
            id="site-footer"
            data-testid="site-footer"
            className="relative pt-16 sm:pt-20 md:pt-24 pb-10"
            style={{ background: "#2e326b" }}
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10">
                <div className="grid md:grid-cols-12 gap-10 sm:gap-12">
                    <div className="md:col-span-5">
                        <div className="inline-block rounded-xl bg-white/95 p-3">
                            <img
                                src={LOGO_URL}
                                alt="HSNC University SAS Logo"
                                className="h-16 sm:h-20 w-auto object-contain"
                            />
                        </div>
                    </div>

                    <div className="md:col-span-7">
                        <p
                            className="text-[11px] tracking-[0.22em] uppercase font-semibold mb-5"
                            style={{ color: "#ffc004" }}
                        >
                            Contact
                        </p>
                        <ul className="space-y-5 text-sm">
                            <li className="flex items-start gap-3">
                                <MapPin
                                    className="h-4 w-4 mt-1 shrink-0"
                                    style={{ color: "#ffc004" }}
                                />
                                <div className="text-white/85 leading-relaxed">
                                    <div>HSNC University, Mumbai</div>
                                    <div>D.M. Harish Building,</div>
                                    <div>47, Dr. R. G. Thadani Marg, Worli,</div>
                                    <div>Mumbai – 400 018.</div>
                                </div>
                            </li>
                            <li className="flex items-center gap-3">
                                <Mail
                                    className="h-4 w-4 shrink-0"
                                    style={{ color: "#ffc004" }}
                                />
                                <a
                                    href="mailto:datascience@hsncu.edu.in"
                                    className="text-white/85 hover:text-white hover:underline break-all"
                                >
                                    Datascience@Hsncu.Edu.In
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 sm:mt-16 pt-6 border-t border-white/15 flex flex-wrap items-center justify-between gap-3">
                    <p className="text-xs text-white/60">
                        © {new Date().getFullYear()} Hsnc University, Mumbai. All Rights Reserved.
                    </p>
                    <p className="text-xs text-white/60">
                        School Of Applied Sciences · Data Science Programs
                    </p>
                </div>
            </div>
        </footer>
    );
}
